import { Navigate, useSearchParams } from "react-router-dom";

/**
 * Sign-up no longer exists as a separate flow — passwordless OTP unifies
 * sign-in and sign-up on the same /sign-in screen. Any user with a fresh
 * email lands on /sign-in, types the address, gets a code, and Supabase
 * auto-creates the account on first verify.
 *
 * This component stays as a permanent redirect so old bookmarks, emails,
 * and any external links still work.
 */
export function SignUpPage() {
  const [params] = useSearchParams();
  const next = params.get("next");
  const target = next ? `/sign-in?next=${encodeURIComponent(next)}` : "/sign-in";
  return <Navigate to={target} replace />;
}
